import { useCallback, useContext } from 'react'
import { AppStateContext } from './AppStateContext'

interface UserResult {
  saveUserId: (userId: number | undefined) => void
  removeUserId: () => void
}

export const useUserId: () => UserResult = () => {
  const { setUserIdInStore, removeUserIdFromStore } = useContext(AppStateContext)
  const saveUserId = useCallback((userId: number | undefined) => setUserIdInStore(userId), [setUserIdInStore])

  const removeUserId = useCallback(() => removeUserIdFromStore(), [removeUserIdFromStore])

  return {
    saveUserId,
    removeUserId,
  }
}
